import { Grid, Typography } from "@mui/material";
import TabelaAtivos from "../../util/tabelas/tabelaAtivos";
import { filter, map, orderBy } from "lodash";
import { useEffect, useState } from "react";
import Posicao from "../../../models/posicao";
import PosicaoAtivo from "../../../models/posicaoAtivo";
import { ClasseAtivo } from "../../../models/enum";
import Imposto from "../../../models/imposto";
import { onSnapshot, query, where } from "firebase/firestore";
import PosicaoDb from "../../../db/posicaoDb";
import PosicaoVencidaDb from "../../../db/posicaoVencidaDb";

interface PosicaoTabProps {
  usuarioId: string;
  imposto: Imposto;
}

export default function PosicaoTab({ usuarioId, imposto }: PosicaoTabProps) {
  const [posicao, setPosicao] = useState<Posicao>();
  const [posicoesVencidas, setPosicoesVencidas] = useState<PosicaoAtivo[]>();

  useEffect(() => {
    if (!!usuarioId) {
      const data = imposto.dataBase.clone();
      return onSnapshot(
        new PosicaoDb().doc({
          usuarioId: usuarioId,
          posicaoId: data.format("YYYY-MM-DD"),
        }),
        (snapshot) => {
          if (snapshot.exists()) setPosicao(snapshot.data());
        }
      );
    }
  }, [usuarioId]);

  useEffect(() => {
    if (!!usuarioId) {
      const data = imposto.dataBase.clone();
      return onSnapshot(
        query(
          new PosicaoVencidaDb().collection({
            usuarioId: usuarioId,
            posicaoVencidaId: "",
          }),
          where("prazo", ">=", data.clone().startOf("month").toDate()),
          where(
            "prazo",
            "<",
            data.clone().add(1, "month").startOf("month").toDate()
          )
        ),
        (query) => setPosicoesVencidas(map(query.docs, (doc) => doc.data()))
      );
    }
  }, [usuarioId]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="eyebrow" color="text.secondary" mt={2} mb={1}>
          Estoque:
        </Typography>
        <TabelaAtivos
          ativos={orderBy(posicao?.posicoes, "codigoAtivo") ?? []}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <Typography variant="eyebrow" color="text.secondary" mt={2} mb={1}>
          Opções Vencidas:
        </Typography>
        <TabelaAtivos
          ativos={filter(
            posicoesVencidas,
            (p) => p.classeAtivo === ClasseAtivo.OPCAO
          )}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <Typography variant="eyebrow" color="text.secondary" mt={2} mb={1}>
          Direitos Vencidos:
        </Typography>
        <TabelaAtivos
          ativos={filter(
            posicoesVencidas,
            (p) => p.classeAtivo === ClasseAtivo.DIREITO
          )}
        />
      </Grid>
    </Grid>
  );
}
